/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const JBP_COMMITTED_SHELF_FRAGMENT = gql`
  fragment JBPCommittedShelf on JBPCommittedShelf {
    id
    shelfQuantity
    category {
      id
      name
    }
  }
`
